

export default {
  menusAreOpened: state => state.sideMenu.opened,
  getFirstBreadcrumb: state => state.breadcrumbs[0],
  getLastBreadcrumb: state => state.breadcrumbs[state.breadcrumbs.length - 1],
};
